import { render, staticRenderFns } from "./FormComponentTextarea.vue?vue&type=template&id=0f4e36e4"
import script from "./FormComponentTextarea.vue?vue&type=script&lang=js"
export * from "./FormComponentTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports